import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import Config from 'conf';
import moment from 'moment';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles, CircularProgress, Grid, Paper, Dialog, DialogContent } from '@material-ui/core';
import { Close as CloseIcon, Check as CheckIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEButton, FHEDivider, BtnPrintEtiquette, FormButtonContainer } from 'data/components';
import { Toastr, Logger } from 'data/common';
import { Element } from '.';
import { reStartTest, goProd, loadEnv, getBoxDetails } from '../../../data/Boxes/actions';
import getSocketMiddlewareInstance from '../../../common/SocketMiddleware';

let timeoutUnconfiguredCenter = null;
let timeoutCallbackTest = null;

function formatMessage(message, type = 'info') {
    return {
        date: moment().format('DD/MM/YYYY HH:mm:ss'),
        message,
        type
    };
}

function checkTest(field, value) {
    switch (field) {
        case 'diskUsed':
            return parseInt(value.replace('%', '')) < 60;
        case 'wifiChannels':
            return parseInt(value) >= 13;
        case 'wifiSSIDs':
            return value.toString() != '-1';
        default:
            Logger.error(`Test ${field} non géré ( diskUsed | wifiChannels | wifiSSIDs )`);
    }
}

class TestingBoxes extends PureComponent {
    static propTypes = {
        Box: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        getBoxDetails: PropTypes.func.isRequired,
        reStartTest: PropTypes.func.isRequired,
        loadEnv: PropTypes.func.isRequired,
        goProd: PropTypes.func.isRequired,
        handleStateOnTest: PropTypes.func.isRequired,
        codeEnv: PropTypes.number.isRequired,
        codePack: PropTypes.number.isRequired,
        boxMac: PropTypes.string.isRequired,
        envBox: PropTypes.string.isRequired,
        centerName: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired,
        disabled: PropTypes.bool
    };
    static defaultProps = {
        disabled: false
    };

    constructor(props) {
        super(props);
        this.state = {
            dataTest: this.initStateTest(),
            step: null, // [onTest, loadEnv, apiCheckBox, midCheckBox, goProd]
            stepsValided: this.initStateStepsValided(),
            loading: false,
            messages: []
        };
    }

    componentDidMount() {
        const socketConnexion = getSocketMiddlewareInstance();
        socketConnexion
            .on('testResult', this.testCallback)
            .on('messageFromBox', this.msgCallback)
            .on('unconfiguredFHECenterConnexion', this.unconfiguredFHECenterCallback);
    }

    componentDidUpdate(prevProps) {
        const { envBox } = this.props;

        if (prevProps.envBox !== envBox) {
            this.resetByEnv(prevProps.envBox, envBox);
        }
    }

    componentWillUnmount() {
        const socketConnexion = getSocketMiddlewareInstance();
        if (socketConnexion) {
            socketConnexion
                .removeListener('testResult', this.testCallback)
                .removeListener('messageFromBox', this.msgCallback)
                .removeListener('unconfiguredFHECenterConnexion', this.unconfiguredFHECenterCallback);
        }
    }

    /** State **/
    initStateTest = () => {
        return {
            diskUsed: {
                data: null,
                test: null
            },
            wifiChannels: {
                data: null,
                test: null
            },
            wifiSSIDs: {
                data: null,
                test: null
            }
        };
    };
    initStateStepsValided = () => {
        return {
            boxTested: null,
            envLoaded: null,
            midBoxChecked: null,
            apiBoxChecked: null,
            boxInProd: null
        };
    };
    resetByEnv = (prevEnvBox, envBox) => {
        const message = formatMessage(
            Translator.translate(
                `testbench.messages.envChanged`,
                Translator.translate(`${prevEnvBox}.centerName`),
                Translator.translate(envBox === 'empty' ? 'testbench.center.title' : `${envBox}.centerName`)
            ),
            'warning'
        );
        this.setState(({ stepsValided, messages }) => {
            return {
                stepsValided: { ...this.initStateStepsValided(), boxTested: stepsValided.boxTested },
                messages: [message, ...messages]
            };
        });
    };

    /** Callback **/
    unconfiguredFHECenterCallback = args => {
        const { box_mac } = args;
        const { centerName, boxMac, Box } = this.props;
        const boxFoundByMid = box_mac === Box.get('macAddress');
        if (!boxFoundByMid) return false;

        if (timeoutUnconfiguredCenter) {
            clearTimeout(timeoutUnconfiguredCenter);
            timeoutUnconfiguredCenter = null;
        }

        const message = formatMessage(
            Translator.translate(`testbench.messages.unconfiguredFHECenterConnexion.success`, centerName, boxMac, box_mac),
            'success'
        );
        this.setState(({ messages, stepsValided }) => {
            return { stepsValided: { ...stepsValided, midBoxChecked: boxFoundByMid }, messages: [message, ...messages] };
        });
        this.getApiBoxDetail();
    };
    testCallback = args => {
        const { dataTest } = this.state;
        const { centerName, boxMac } = this.props;
        if (!Object.keys(dataTest).includes(args.test)) return false;
        if (timeoutCallbackTest) {
            clearTimeout(timeoutCallbackTest);
            timeoutCallbackTest = null;
        }
        timeoutCallbackTest = setTimeout(() => {
            timeoutCallbackTest = null;

            this.setState(({ messages }) => {
                return {
                    step: null,
                    messages: [formatMessage(Translator.translate(`testbench.messages.startTest.error`, centerName, boxMac), 'error'), ...messages]
                };
            });
        }, 1000 * 60 * 5);

        let testFinished = true;
        let resOfTest = true;
        const resTestValue = checkTest(args.test, args.result);

        Object.keys(dataTest).map(field => {
            if (field === args.test) resOfTest = resOfTest && resTestValue;
            else {
                resOfTest = resOfTest && dataTest[field].test;
                if (dataTest[field].test === null) testFinished = false;
            }
        });
        if (testFinished && timeoutCallbackTest) {
            clearTimeout(timeoutCallbackTest);
            timeoutCallbackTest = null;
        }

        this.setState(({ messages, stepsValided }) => {
            const messageStep = formatMessage(
                Translator.translate(
                    `testbench.messages.stepTest.${resTestValue ? 'resultOk' : 'resultKo'}`,
                    Translator.translate(`testbench.test.${args.test}`),
                    centerName,
                    boxMac
                ),
                resTestValue ? 'success' : 'error'
            );
            const res = {
                dataTest: { ...dataTest, [args.test]: { data: args.result, test: resTestValue } },
                stepsValided: { ...stepsValided, boxTested: resOfTest },
                loading: !testFinished,
                messages: [messageStep, ...messages]
            };
            if (testFinished) {
                const message = formatMessage(
                    Translator.translate(`testbench.messages.startTest.success.${resOfTest ? 'resultOk' : 'resultKo'}`, centerName, boxMac),
                    resOfTest ? 'success' : 'error'
                );
                res.messages = [message, ...res.messages, ...messages];
            }
            return res;
        });
    };
    msgCallback = args => {
        this.setState(({ messages }) => {
            return { messages: [formatMessage(args.msg, 'box'), ...messages] };
        });
    };

    /** Action **/
    reStartTest = () => {
        const { reStartTest, handleStateOnTest, Box, centerName, boxMac } = this.props;
        const message = formatMessage(Translator.translate(`testbench.messages.startTest.action`, centerName, boxMac));

        this.setState(({ messages, stepsValided }) => {
            return {
                step: 'onTest',
                stepsValided: { ...stepsValided, boxTested: null },
                dataTest: this.initStateTest(),
                loading: true,
                messages: [message, ...messages]
            };
        });
        handleStateOnTest(Box.get('macAddress'));
        reStartTest(Box.get('macAddress')).catch(() => {
            const message = Translator.translate(`testbench.messages.startTest.error`, centerName, boxMac);
            this.setState(({ messages, stepsValided }) => {
                return {
                    stepsValided: { ...stepsValided, boxTested: false },
                    messages: [formatMessage(message, 'error'), ...messages]
                };
            });
        });
    };
    loadEnv = () => {
        const { Box, loadEnv, centerName, boxMac } = this.props;
        this.setState(({ messages, stepsValided }) => {
            return {
                loading: true,
                step: 'loadEnv',
                stepsValided: { ...stepsValided, envLoaded: null },
                messages: [formatMessage(Translator.translate(`testbench.messages.loadEnv.action`, centerName, boxMac)), ...messages]
            };
        });
        loadEnv(Box.get('macAddress'))
            .then(() => {
                const message = Translator.translate(`testbench.messages.loadEnv.success`, centerName, boxMac);
                this.setState(({ messages, stepsValided }) => {
                    return {
                        stepsValided: { ...stepsValided, envLoaded: true },
                        messages: [formatMessage(message, 'success'), ...messages]
                    };
                });
                return this.startUnconfiguredFHECenterConnexion();
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                this.setState(({ messages, stepsValided }) => {
                    return {
                        loading: false,
                        stepsValided: { ...stepsValided, envLoaded: false },
                        messages: [formatMessage(message, 'error'), ...messages]
                    };
                });
            });
    };
    startUnconfiguredFHECenterConnexion = () => {
        const { centerName, boxMac } = this.props;
        if (timeoutUnconfiguredCenter) {
            clearTimeout(timeoutUnconfiguredCenter);
            timeoutUnconfiguredCenter = null;
        }

        timeoutUnconfiguredCenter = setTimeout(() => {
            timeoutUnconfiguredCenter = null;
            this.setState(({ messages, stepsValided }) => {
                return {
                    stepsValided: { ...stepsValided, midBoxChecked: false },
                    loading: false,
                    messages: [
                        formatMessage(Translator.translate(`testbench.messages.unconfiguredFHECenterConnexion.timeout`, centerName, boxMac), 'error'),
                        ...messages
                    ]
                };
            });
        }, 1000 * 60 * 5);
        this.setState(({ messages, stepsValided }) => {
            return {
                stepsValided: { ...stepsValided, midBoxChecked: null },
                step: 'startUnconfigured',
                messages: [
                    formatMessage(Translator.translate(`testbench.messages.unconfiguredFHECenterConnexion.action`, centerName, boxMac)),
                    ...messages
                ]
            };
        });
    };
    getApiBoxDetail = () => {
        const { Box, envBox, getBoxDetails, centerName, boxMac } = this.props;
        this.setState(({ messages, stepsValided }) => {
            return {
                loading: true,
                step: 'checkBoxApi',
                stepsValided: { ...stepsValided, apiBoxChecked: null },
                messages: [formatMessage(Translator.translate(`testbench.messages.checkBoxApi.action`, centerName, boxMac)), ...messages]
            };
        });
        getBoxDetails(envBox, Box.get('macAddress'))
            .then(() => {
                const message = Translator.translate(`testbench.messages.checkBoxApi.success`, centerName, boxMac);
                this.setState(({ messages, stepsValided }) => {
                    return {
                        loading: false,
                        stepsValided: { ...stepsValided, apiBoxChecked: true },
                        messages: [formatMessage(message, 'success'), ...messages]
                    };
                });
            })
            .catch(err => {
                const message =
                    err.message === 'BOX_NOT_FOUND'
                        ? Translator.translate(`testbench.messages.checkBoxApi.error`, centerName, boxMac)
                        : Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                this.setState(({ messages, stepsValided }) => {
                    return {
                        loading: false,
                        stepsValided: { ...stepsValided, apiBoxChecked: false },
                        messages: [formatMessage(message, 'error'), ...messages]
                    };
                });
            });
    };
    goProduction = () => {
        const { goProd, envBox, codePack, Box, handleStateOnTest, boxMac, centerName } = this.props;
        Toastr.confirm(
            Translator.translate(`testbench.messages.goProd.ConfirmationText`),
            Translator.translate(`testbench.messages.goProd.ConfirmationTitle`, centerName, boxMac),
            {
                onYes: () => {
                    this.setState(({ messages, stepsValided }) => {
                        return {
                            loading: true,
                            step: 'goProd',
                            stepsValided: { ...stepsValided, boxInProd: null },
                            messages: [formatMessage(Translator.translate(`testbench.messages.goProd.action`, centerName, boxMac)), ...messages]
                        };
                    });
                    goProd(envBox, Box.get('macAddress'), codePack)
                        .then(() => {
                            const message = Translator.translate(`testbench.messages.goProd.success`, centerName, boxMac);
                            handleStateOnTest();
                            this.setState(({ messages, stepsValided }) => {
                                return {
                                    loading: false,
                                    stepsValided: { ...stepsValided, boxInProd: true },
                                    messages: [formatMessage(message, 'success'), ...messages]
                                };
                            });
                        })
                        .catch(err => {
                            const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                            this.setState(({ messages, stepsValided }) => {
                                return {
                                    loading: false,
                                    stepsValided: { ...stepsValided, boxInProd: false },
                                    messages: [formatMessage(message, 'error'), ...messages]
                                };
                            });
                        });
                }
            }
        );
    };

    /** Render **/
    renderButtons = () => {
        const { stepsValided, loading, step } = this.state;
        const { disabled, centerName, envBox } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={4}>
                    <FHEButton
                        content={Translator.translate(`testbench.buttons.reStartTest`)}
                        loading={loading && step === 'onTest'}
                        disabled={disabled || (loading && step !== 'onTest')}
                        clickFunction={this.reStartTest}
                    />
                </Grid>
                <Grid container item sm={12} md={4}>
                    <FHEButton
                        content={Translator.translate(`testbench.buttons.loadEnv`, centerName)}
                        loading={loading && (step === 'loadEnv' || step === 'startUnconfigured' || step === 'checkBoxApi')}
                        disabled={disabled || (loading && step !== 'loadEnv') || envBox === 'empty' || !stepsValided.boxTested}
                        clickFunction={this.loadEnv}
                    />
                </Grid>
                <Grid container item sm={12} md={4}>
                    <FHEButton
                        content={Translator.translate(`testbench.buttons.goProd`)}
                        loading={loading && step === 'goProd'}
                        disabled={disabled || (loading && step !== 'goProd') || envBox === 'empty' || !stepsValided.apiBoxChecked}
                        clickFunction={this.goProduction}
                    />
                </Grid>
            </Grid>
        );
    };
    renderBoxeInfos = () => {
        const { loading, Box, boxMac } = this.props;
        if (loading) return <CircularProgress size={25} />;
        return (
            <Grid container spacing={0}>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate('general.table.column.macAddress')} value={boxMac} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate(`general.table.column.id`)} value={Box.get('boxId')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate('general.table.column.homeId')} value={Box.get('homeId')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate('general.table.column.firmwareVersion')} value={Box.get('firmwareVersion')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate('general.table.column.tester')} value={Box.get('tester')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <Element title={Translator.translate('general.table.column.provisionedDate')} value={Box.get('provisionedDate')} />
                </Grid>
            </Grid>
        );
    };
    renderTestValue = field => {
        let { dataTest } = this.state;
        const { classes } = this.props;
        let value = dataTest[field].data;
        if (value === null) return null;

        return (
            <div className="d-flex">
                <div className="pr-2"> {value} </div>
                {checkTest(field, value) ? <CheckIcon classes={{ root: classes.checkIcon }} /> : <CloseIcon color="error" />}
            </div>
        );
    };
    renderBoxeTest = () => {
        return (
            <Grid container spacing={0}>
                <Grid container item xs={12} md={6} lg={4}>
                    <Element title={Translator.translate(`testbench.test.diskUsed`)} value={this.renderTestValue('diskUsed')} />
                </Grid>
                <Grid container item xs={12} md={6} lg={4}>
                    <Element title={Translator.translate(`testbench.test.wifiChannels`)} value={this.renderTestValue('wifiChannels')} />
                </Grid>
                <Grid container item xs={12} md={6} lg={4}>
                    <Element title={Translator.translate(`testbench.test.wifiSSIDs`)} value={this.renderTestValue('wifiSSIDs')} />
                </Grid>
            </Grid>
        );
    };
    renderBoxeLogs = () => {
        const { messages } = this.state;
        const { classes } = this.props;
        const logs = [];

        messages.map((data, i) => {
            logs.push(<div key={i} className={classes[`logs_${data.type}`]}>{`${data.date} : ${data.message}`}</div>);
        });

        return logs;
    };
    renderBoxValided = () => {
        const { stepsValided } = this.state;
        const { classes, centerName, boxMac } = this.props;

        return (
            <Dialog aria-labelledby="customized-dialog-title" open={!!stepsValided.boxInProd} fullWidth maxWidth="md">
                <DialogContent>
                    <div className={classes.success}>{Translator.translate(`testbench.messages.boxValided`, centerName, boxMac)}</div>
                </DialogContent>
            </Dialog>
        );
    };

    render() {
        const { classes, centerName, boxMac, Box, codeEnv, codePack, envBox } = this.props;
        return (
            <Fragment>
                <FormButtonContainer
                    buttons={
                        <BtnPrintEtiquette
                            key="print"
                            boxId={Box.get('boxId')}
                            codeEnv={codeEnv}
                            codePack={codePack}
                            envBox={envBox}
                            boxMac={boxMac}
                        />
                    }
                />
                {this.renderBoxValided()}
                <FHEDivider title={Translator.translate(`testbench.divider.titleTest`, centerName, boxMac)} />
                <FHEContainerForm> {this.renderBoxeInfos()}</FHEContainerForm>
                <FHEDivider title={Translator.translate(`testbench.divider.resultTest`)} />
                <FHEContainerForm> {this.renderBoxeTest()}</FHEContainerForm>
                {this.renderButtons()}
                <FHEDivider title={Translator.translate(`testbench.divider.logs`)} />
                <Paper className={classes.containerLogs}>{this.renderBoxeLogs()}</Paper>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { Box, envBox } = props;
    const packBox = state.environments.testbench.data.Packs.get('active');

    return {
        centerName: Translator.translate(envBox === 'empty' ? 'testbench.center.title' : `${envBox}.centerName`),
        codeEnv: state.data.configEnvs.getIn([envBox, 'code'], null),
        codePack: state.environments.testbench.data.Packs.getIn(['list', packBox, 'code'], 0),
        envBox,
        boxMac: Box.get('macAddress')
            .match(/.{1,2}/g)
            .join(':')
    };
}

const styles = theme => ({
    success: {
        color: theme.palette.success.main,
        fontSize: 40,
        margin: 50,
        textAlign: 'center'
    },
    logs_box: {
        color: theme.palette.fheColors.primary.main
    },
    logs_success: {
        color: theme.palette.success.main
    },
    logs_info: {
        color: theme.palette.text.primary
    },
    logs_warning: {
        color: theme.palette.warning.main
    },
    logs_error: {
        color: theme.palette.error.main
    },
    title: {
        color: theme.palette.primary.main
    },
    printIcon: {
        position: 'absolute',
        top: 50,
        right: 50,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('sm')]: {
            top: 30,
            right: 30
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 18,
            height: 30,
            width: 30
        }
    },
    containerLogs: {
        height: 200,
        width: '100%',
        overflow: 'auto',
        marginTop: 20,
        padding: 15
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ reStartTest, goProd, loadEnv, getBoxDetails }, dispatch)
    )(withStyles(styles, { withTheme: true })(TestingBoxes))
);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/components/TestingBoxes.js